export default {
  login: {
    title: 'Đăng nhập vào mypage',
    double_check_text: 'Dữ liệu không chính xác. Vui lòng xác nhận rằng bạn đã nhập dữ liệu chính xác.',
    id_email: 'ID/địa chỉ email',
    password: 'Mật khẩu',
    password_display: 'Hiện mật khẩu',
    password_no_display: 'Ẩn mật khẩu',
    login: 'Đăng nhập',
    keep_login_text: 'Duy trì trạng thái đăng nhập',
    forgot_password_text: 'Quên mật khẩu',
    contact_us: 'Đăng ký tại đây',
    asuene_service_outline: '"ASUENE", Dịch vụ đám mây trực quan hóa CO2',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'Nền tảng tuyển dụng tập trung vào tài năng GX/ESG "ASUENE CAREER"',
    corporate_page: 'Trang web công ty',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
